/** CSS contract: css-library/components/02-containers/bar.css. */
import type { Ref } from 'react';
import type { HTMLAttributes, MouseEvent, ReactNode } from 'react';
import { cx } from '../lib/cx';
import { HeaderPill, type HeaderPillSpec } from './HeaderPill';
import { ModalCloseButton } from './ModalCloseButton';
import { Button } from './Button';
import { Icon } from './Icon';
import { Pill } from './Pill';
import { HoverDisclosureGroup } from '../lib/useHoverDisclosure';

export interface TopBarProps extends HTMLAttributes<HTMLElement> {
  left?: HeaderPillSpec;
  close?: { label: string; disabled?: boolean; testId?: string };
  back?: { label: string; onClick: (event: MouseEvent<HTMLButtonElement>) => void; disabled?: boolean };
  start?: ReactNode;
  leftProps?: Omit<HTMLAttributes<HTMLDivElement>, 'children' | 'dangerouslySetInnerHTML'> & { [key: `data-${string}`]: string | number | boolean | undefined };
  center?: ReactNode;
  right?: ReactNode;
}

export function TopBar(
  { ref, left, leftProps, close, back, start, center, right, className, children, ...rest }: TopBarProps & { ref?: Ref<HTMLElement> },
) {
  const navigation = left?.type === 'tabs';
  return (
    <HoverDisclosureGroup><header ref={ref} className={cx('bar', navigation && 'bar--navigation', className)} {...rest}>
      <div {...leftProps} className={cx('bar-left', leftProps?.className)}>
        {close && <ModalCloseButton data-testid={close.testId} title={close.label} aria-label={close.label} disabled={close.disabled} />}
        {back && <Pill><Button iconOnly title={back.label} disabled={back.disabled} onClick={back.onClick}>
          <Icon name="i-arrow-left" mirrorRtl />
        </Button></Pill>}
        {start}
        {navigation ? center : left != null && <HeaderPill value={left} />}
      </div>
      {(navigation || center != null) && <div className="bar-center">{navigation ? <HeaderPill value={left} /> : center}</div>}
      <div className="bar-right">{right}</div>
      {children}
    </header></HoverDisclosureGroup>
  );
}
